import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export const deleteCarService = async (_id: string, companyId: string) => {
  try {
    const response = await axiosInstance.delete(
      `${config.apiUrl}/car-services/${_id}?companyId=${companyId}`
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Error deleting car service"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
};
